export default __webpack_public_path__ + "static/media/mainMobile.4f01f191.jpg";